// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Bed from '../_raw/service/icon_bed.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Bed);
